import handlebars from "handlebars";

export const compileTemplate = (template: string, entity = {}): string => {
  return handlebars.compile(template)(entity);
};

export const compileUnescapedTextTemplate = ({
  template,
  data,
}: {
  template: string;
  data: object;
}): string => {
  return handlebars.compile(template, { noEscape: true })(data);
};

export const extractTemplateVariables = (template: string): string[] => {
  const regex = /{{{\s*([\w.]+)\s*}}}|{{\s*([\w.]+)\s*}}/g;
  return Array.from(
    template.matchAll(regex),
    (m: RegExpMatchArray) => m[1] || m[2],
  );
};
